module.exports = __webpack_public_path__ + "static/media/cookie_plate_3.4557dd0d.png";